export default __webpack_public_path__ + "static/media/dashboard-active.1941c4db.svg";